export const EnvConstants = {
  DEV: "dev",
  STG: "stg",
  PROD: "prod"
};
